import { httpClient } from '@/modules/common/services/http/http-client';

import { IDailyBrokerageNoteBody, IYearlyBrokerageNoteBody } from './types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/trade`
});

export const httpReports = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/reports`
});

export function getDailyBrokerageNote(
  path: string
): Promise<IDailyBrokerageNoteBody> {
  return httpReports.get('/v1/trading-notes/variable-income', {
    params: { path }
  });
}

export function getYearlyBrokerageNote(
  year: string
): Promise<IYearlyBrokerageNoteBody> {
  return http.get('/v1/brokerageNotesZip', {
    params: { year }
  });
}
